import type { Id, Team } from '../types.js';
import type { Rng } from '../rng.js';

/**
 * Setzliste (docs/04 §1). Ergebnis: Rangliste 1…n.
 * - teamSeed: gesetzte Teams nach Setzung, ungesetzte danach zufällig ("gemischt")
 * - random:   alles zufällig
 * - ranked:   vorgegebene Reihenfolge (aus Vorphase)
 */
export function rankTeams(teams: readonly Team[], source: 'teamSeed' | 'random', rng: Rng): Id[] {
  if (source === 'random') return rng.shuffle(teams.map((t) => t.id));
  const seeded = teams.filter((t) => t.seed !== undefined).sort((a, b) => (a.seed as number) - (b.seed as number));
  const rest = rng.shuffle(teams.filter((t) => t.seed === undefined).map((t) => t.id));
  return [...seeded.map((t) => t.id), ...rest];
}

/** Teams, die an einer Auslosung teilnehmen */
export function eligibleTeams(teams: readonly Team[]): Team[] {
  return teams.filter((t) => t.status === 'registered' || t.status === 'confirmed');
}
